import React from 'react'
import {HEADER_LAYOUT} from '@wix/wix-events-commons-statics'
import {SideBySideLayout} from './side-by-side-layout'
import {ClassicLayout} from './classic-layout'
import {HeaderProps} from './index'

export const Header: React.FC<HeaderProps> = ({onClickRegistrationButton, headerLayout}) => {
  return headerLayout === HEADER_LAYOUT.SIDE_BY_SIDE ? (
    <SideBySideLayout onClickRegistrationButton={onClickRegistrationButton} />
  ) : (
    <ClassicLayout onClickRegistrationButton={onClickRegistrationButton} />
  )
}
